import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {ColumnFilter, Observation, Project, Publication, Tab} from "../model/asax-result-table.model";

@Injectable({
  providedIn: 'root'
})
export class AsaxResultTableService {
  private activeTabSubject = new BehaviorSubject<Tab>(undefined);
  private activeTabIdSubject = new BehaviorSubject<string>(undefined);

  private columnsFiltersForActiveTabSubject = new BehaviorSubject<ColumnFilter[]>(undefined);

  private rowHoveredSubject = new Subject<Observation | Project | Publication>();

  getActiveTabId(): Observable<string> {
    return this.activeTabIdSubject.asObservable();
  }

  getActiveTabIdValue(): string {
    return this.activeTabIdSubject.getValue();
  }

  setActiveTabId(activeTabId: string): void {
    this.activeTabIdSubject.next(activeTabId);
  }

  getActiveTab(): Observable<Tab> {
    return this.activeTabSubject.asObservable();
  }

  setActiveTab(activeTab: Tab): void {
    this.activeTabSubject.next(activeTab);
  }

  getRowHovered(): Observable<Observation | Project | Publication> {
    return this.rowHoveredSubject.asObservable();
  }

  setRowHovered(rowHovered: Observation | Project | Publication): void {
    this.rowHoveredSubject.next(rowHovered);
  }

  getColumnsFiltersForActiveTabSubject(): Observable<ColumnFilter[]> {
    return this.columnsFiltersForActiveTabSubject.asObservable();
  }

  setColumnsFiltersForActiveTabSubject(columnsFilters: ColumnFilter[]): void {
    this.columnsFiltersForActiveTabSubject.next(columnsFilters);
  }
}
